export const DATA_ATTR_REGEX = /^data[A-Z]/;
